/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tournaments_Lib_Rounds_Choice_Swiss_Bo1Inputs */



/**
* | output |
* | --- |
* | "Swiss - BO1" |
*
* @param {Tournaments_Lib_Rounds_Choice_Swiss_Bo1Inputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
export const tournaments_lib_rounds_choice_swiss_bo1 = /** @type {((inputs?: Tournaments_Lib_Rounds_Choice_Swiss_Bo1Inputs, options?: { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournaments_Lib_Rounds_Choice_Swiss_Bo1Inputs, { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Schweizer System - BO1")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Suisse - BO1")
	if (locale === "zh-Hans") return /** @type {LocalizedString} */ ("瑞士轮 - BO1")
	if (locale === "zh-Hant") return /** @type {LocalizedString} */ ("瑞士制 - BO1")
	if (locale === "ko") return /** @type {LocalizedString} */ ("스위스 - BO1")
	return /** @type {LocalizedString} */ ("Swiss - BO1")
});